<template>
  <span class="resources-filter__option-categories js-filter-options">
    <div class="resources-filter__search-only js-search-only hidden">
      <div class="resources-filter__search-box-container">
        <input
          type="text"
          class="js-resources-filter-search"
          placeholder="Search By Name"
          :value="searchTerm"
          @input="updateSearchTerm"
        />
        <svg class="icon icon-search align-top">
          <use xlink:href="#icon-search"></use>
        </svg>
      </div>
    </div>
    <div
      class="resources-filter__option-category js-option-category"
      :if="sampleTypes.length > 0"
    >
      <div class="resources-filter__search-box-container">
        <input
          type="text"
          class="js-resources-filter-search"
          placeholder="Search By Name"
          :value="searchTerm"
          @input="updateSearchTerm"
        />
        <svg class="icon icon-search align-top">
          <use xlink:href="#icon-search"></use>
        </svg>
      </div>
      <hr class="resources-filter__hr--first" />
      <div
        class="
          resources-filter__option-category-name-wrapper
          js-sample-types-toggle
        "
      >
        <span class="resources-filter__option-category-name">
          Material
        </span>
      </div>
      <div class="resources-filter__options js-resources-sample-types">
        <div
          class="resources-filter__option js-resources-sample-type"
          v-for="sampleType in sampleTypes"
          :key="sampleType.slug"
          :data-slug="sampleType.slug"
        >
          <label class="resources-filter__option-label">
            <span
              class="
                resources-filter__option-label-checkbox
                resources-filter__option-label-checkbox--radio
              "
            >
              <input
                type="radio"
                name="sample_type"
                :checked="sampleType.slug === selectedSampleType"
                @click="updateSelectedSampleType(sampleType, $event)"
              />
              <div />
            </span>
            <span class="resources-filter__option-label-text">
              {{ sampleType.filterOptionText }}
            </span>
          </label>
        </div>
      </div>
      <hr class="resources-filter__hr" />
    </div>
    <div
      class="resources-filter__option-category js-option-category"
      v-for="optionsCategory in filterOptionsCategories"
      :key="optionsCategory.id"
    >
      <div
        class="
          resources-filter__option-category-name-wrapper
          js-category-options-toggle
        "
        :data-category="optionsCategory.id"
        @click="toggleCategoryOptions"
      >
        <span class="resources-filter__option-category-name">
          {{ optionsCategory.humanizedCategory }}
        </span>
        <span class="js-category-collapse-icon-container">
          <svg
            class="icon icon-plus js-category-collapse-icon js-sample-types-toggle"
            aria-hidden="true"
            focusable="false"
          >
            <use xlink:href="#icon-plus"></use>
          </svg>
          <svg
            class="icon icon-minus js-category-collapse-icon hidden js-sample-types-toggle"
            aria-hidden="true"
            focusable="false"
          >
            <use xlink:href="#icon-minus"></use>
          </svg>
        </span>
      </div>
      <div
        class="resources-filter__options js-resources-filter-options hidden"
        :data-category="optionsCategory.id"
      >
        <div
          class="resources-filter__option js-resources-filter-option"
          v-for="optionData in optionsCategory.options"
          :key="`${optionsCategory.id}-${optionData.id}`"
          :data-value="optionData.value"
        >
          <label class="resources-filter__option-label">
            <span class="resources-filter__option-label-checkbox">
              <input
                type="checkbox"
                @click="
                  updateSelectedFilters(optionsCategory, optionData, $event)
                "
              />
              <div />
            </span>
            <span class="resources-filter__option-label-text">
              {{ optionData.humanizedOption }}
            </span>
          </label>
        </div>
      </div>
      <hr class="resources-filter__hr" />
    </div>
    <div class="resources-filter__mobile-buttons-wrapper js-mobile-buttons">
      <span class="resources-filter__clear-all--mobile" @click="clearFilters">
        <span>Clear Filter</span>
      </span>
      <span
        class="resources-filter__apply-filters-button"
        @click="toggleCategories"
      >
        <span>Apply Filter</span>
      </span>
    </div>
  </span>
</template>

<script>
import IconBase from '../icons/IconBase';
import IconDropdownArrow from '../icons/IconDropdownArrow';
import { eventBus, REFRESH_SEARCH } from '../shared/event-bus';
import { setElementHeight } from '../../helpers/helpers';

export default {
  name: 'ResourcesFilterOptions',
  props: [
    'filterOptionsCategories',
    'selectedFilters',
    'searchTerm',
    'sampleTypes',
    'selectedSampleType',
  ],
  data() {
    return {
      searchTermTimeoutID: null,
    };
  },
  mounted() {
    eventBus.$on(REFRESH_SEARCH, () => {
      const search = document.querySelector('.js-resources-filter-search');

      search.value = '';
      eventBus.updateSearchTerm(search.value);
    });
  },
  methods: {
    toggleCategoryOptions(event) {
      const category = event.target.closest(
          '.js-category-options-toggle[data-category]'
        ),
        options = category.parentNode.querySelector(
          `.js-resources-filter-options[data-category="${category.getAttribute(
            'data-category'
          )}"]`
        ),
        svgs = category.parentNode.querySelectorAll('svg') || [];

      svgs.forEach(svg => this.elementToggleHidden(svg));
      this.elementToggleHidden(options);
    },
    elementToggleHidden(el) {
      el.classList.contains('hidden')
        ? el.classList.remove('hidden')
        : el.classList.add('hidden');
    },
    updateSelectedFilters(category, option, event) {
      let skipFetch;
      if (event.hasOwnProperty('skipFetch')) {
        skipFetch = event.skipFetch;
      } else {
        skipFetch = false;
      }

      eventBus.updateSelectedFilters({
        category,
        option,
        checked: event.target.checked,
        skipFetch,
      });
    },
    updateSelectedSampleType(sampleType, event) {
      eventBus.updateSelectedSampleType({ sampleType, event });
    },
    updateSearchTerm(event) {
      // Avoid making requests while the user is still typing with a timeout
      if (this.searchTermTimeoutID !== null) {
        clearTimeout(this.searchTermTimeoutID);
      }

      this.searchTermTimeoutID = setTimeout(() => {
        eventBus.updateSearchTerm(event.target.value);

        this.searchTermTimeoutID = null;
      }, 300);
    },
    clearFilters() {
      eventBus.clearAllFilters();
      eventBus.toggleCategories();
      window.scroll(0, 0);
    },
    toggleCategories() {
      eventBus.toggleCategories();
      window.scroll(0, 0);
    },
  },
};
</script>
